// This module is using axios: https://github.com/axios/axios
import axios from 'axios';

const REQUEST_TIMEOUT = 60000; // default request timeout in ms, 1min

const request = ({ url, ...rest }) => {
  const config = {
    timeout: REQUEST_TIMEOUT,
    withCredentials: true,
    ...rest,
  };
  return axios.get(url, config);
};

export const requestWithRetry = async (config, n = 2) => {
  if (n < 1) throw new Error('Retry cannot be less than 1');
  try {
    return await request(config);
  } catch (err) {
    if (n === 1) throw err;
    return requestWithRetry(config, n - 1);
  }
};

const putRequest = ({ data, url, timeout, ...rest }) => {
  const config = {
    timeout: timeout || REQUEST_TIMEOUT,
    withCredentials: true,
    ...rest,
  };
  return axios.put(url, data, config);
};

export const putRequestWithRetry = async (config, n = 2) => {
  if (n < 1) throw new Error('Retry cannot be less than 1');
  try {
    return await putRequest(config);
  } catch (err) {
    if (n === 1) throw err;
    return putRequestWithRetry(config, n - 1);
  }
};

const postRequest = ({ url, data, timeout, ...rest }) => {
  const config = {
    timeout: timeout || REQUEST_TIMEOUT,
    withCredentials: true,
    headers: {
      ['anti-csrftoken-a2z']: window.__AAC_FIT_CSRF_TOKEN__,
    },
    ...rest,
  };
  return axios.post(url, data, config);
};

export const postRequestWithRetry = async (config, n = 2) => {
  if (n < 1) throw new Error('Retry cannot be less than 1');
  try {
    return await postRequest(config);
  } catch (err) {
    if (n === 1) throw err;
    return postRequestWithRetry(config, n - 1);
  }
};
